jQuery(function ($) {
    let singleCarPageParent = $("body");

    function trackAnalyticsEvent(eventName, payload) {
        if (window.CarBuyAnalytics && typeof window.CarBuyAnalytics.track === 'function') {
            window.CarBuyAnalytics.track(eventName, payload || {});
        }
    }

    function trackMetaEvent(eventName, payload) {
        if (window.CarBuyMetaPixel && typeof window.CarBuyMetaPixel.track === 'function') {
            window.CarBuyMetaPixel.track(eventName, payload || {});
        }
    }

    function vehicleMetaPayload(carId, extra) {
        if (window.CarBuyMetaPixel && typeof window.CarBuyMetaPixel.findVehiclePayloadByCarId === 'function') {
            return window.CarBuyMetaPixel.findVehiclePayloadByCarId(carId, extra || {});
        }
        return Object.assign({ car_id: carId }, extra || {});
    }

    const initialCarId = $('.favorite-toggle[data-car-id], .price-watch-toggle[data-car-id], .reveal-phone[data-car-id]').first().data('car-id');
    if (initialCarId) {
        trackAnalyticsEvent('vehicle_view', { car_id: initialCarId });
        trackMetaEvent('ViewContent', vehicleMetaPayload(initialCarId));
    }

    // COPY CURRENT PAGE LINK
    const singleCarCopyUrlWrapper = $(".copy-current-url-wrapper");
    const singleCarCopyUrlSuccess = singleCarCopyUrlWrapper.find(".copy-status-success");
    const singleCarCopyUrlError = singleCarCopyUrlWrapper.find(".copy-status-error");
    
    // Fallback copy method for HTTP or older browsers
    function fallbackCopyTextToClipboard(text, resolve, reject) {
        const textArea = document.createElement("textarea");
        textArea.value = text;
        textArea.style.position = "fixed";
        textArea.style.left = "-999999px";
        textArea.style.top = "-999999px";
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
        
        try {
            const successful = document.execCommand('copy');
            document.body.removeChild(textArea);
            if (successful) {
                resolve();
            } else {
                reject(new Error('Copy command was unsuccessful'));
            }
        } catch (err) {
            document.body.removeChild(textArea);
            reject(err);
        }
    }
    
    // Copy to clipboard function with fallback
    function copyToClipboardSafe(text) {
        return new Promise((resolve, reject) => {
            // Try UniversalHelpers first if available (wait a bit for it to load)
            if (window.UniversalHelpers && typeof window.UniversalHelpers.copyToClipboard === 'function') {
                try {
                    window.UniversalHelpers.copyToClipboard(text).then(resolve).catch(reject);
                    return;
                } catch (e) {
                    // If UniversalHelpers fails, fall through to fallback
                }
            }
            
            // Fallback: Modern Clipboard API (requires HTTPS)
            if (navigator.clipboard && window.isSecureContext) {
                navigator.clipboard.writeText(text).then(resolve).catch(() => {
                    // If clipboard API fails, try fallback method
                    fallbackCopyTextToClipboard(text, resolve, reject);
                });
                return;
            }
            
            // Fallback: Legacy method
            fallbackCopyTextToClipboard(text, resolve, reject);
        });
    }
    
    singleCarPageParent.on("click", ".single-car-hero-button-copy-url", function (e) {
        e.preventDefault();
        const currentUrl = window.location.href;
        
        copyToClipboardSafe(currentUrl).then(() => {
            // Hide any existing messages
            singleCarCopyUrlError.slideUp();
            singleCarCopyUrlSuccess.slideDown();
            setTimeout(function () {
                singleCarCopyUrlSuccess.slideUp();
            }, 3000);
        }).catch(err => {
            // Failed to copy URL
            // Hide any existing messages
            singleCarCopyUrlSuccess.slideUp();
            singleCarCopyUrlError.slideDown();
            setTimeout(function () {
                singleCarCopyUrlError.slideUp();
            }, 3000);
        });
    });
    // END COPY CURRENT PAGE LINK

    // EMAIL ADDRESS TRACKING (reveal behavior is shared in contact-reveal.js)
    document.addEventListener('carbuy:email-revealed', function (event) {
        const carId = event.detail && event.detail.carId;
        if (!carId) return;

        trackAnalyticsEvent('email_click', { car_id: carId, contact_type: 'seller' });
        trackAnalyticsEvent('vehicle_contact_intent', { car_id: carId, contact_type: 'email' });
        trackMetaEvent('Contact', vehicleMetaPayload(carId, { contact_type: 'email' }));
        csrfSafeAjaxPost('/ajax/track-email', { car_id: carId }, function(response) {
            // Email click tracked
        });
    });
    // END EMAIL ADDRESS TRACKING

    // PHONE NUMBER TRACKING (reveal behavior is shared in contact-reveal.js)
    document.addEventListener('carbuy:phone-revealed', function (event) {
        const carId = event.detail && event.detail.carId;
        if (!carId) return;

        trackAnalyticsEvent('phone_click', { car_id: carId, contact_type: 'seller' });
        trackAnalyticsEvent('vehicle_contact_intent', { car_id: carId, contact_type: 'phone' });
        trackMetaEvent('Contact', vehicleMetaPayload(carId, { contact_type: 'phone' }));
        csrfSafeAjaxPost('/ajax/track-phone-call', { car_id: carId }, function(response) {
            // Phone call tracked
        });
    });
    // END PHONE NUMBER TRACKING

    // WHATSAPP REVEAL AND TRACKING
    singleCarPageParent.on("click", ".reveal-whatsapp", function (e) {
        const $btn = $(this);
        e.preventDefault();

        const carId = $btn.data('car-id');
        const encodedPhone = $btn.data('wa-phone');
        const encodedText = $btn.data('wa-text');

        if (encodedPhone) {
            try {
                const phone = atob(encodedPhone);
                let url = 'https://wa.me/' + phone;
                
                if (encodedText) {
                    const text = atob(encodedText);
                    // Text is already URL-encoded from server (to handle UTF-8 correctly through base64)
                    url += '?text=' + text;
                }

                // Track click
                if (carId) {
                    trackAnalyticsEvent('whatsapp_click', { car_id: carId, contact_type: 'seller' });
                    trackAnalyticsEvent('vehicle_contact_intent', { car_id: carId, contact_type: 'whatsapp' });
                    trackMetaEvent('Contact', vehicleMetaPayload(carId, { contact_type: 'whatsapp' }));
                    csrfSafeAjaxPost('/ajax/track-whatsapp', { car_id: carId }, function(response) {
                        // WhatsApp click tracked
                    });
                }

                // Open in new tab
                window.open(url, '_blank');
            } catch (err) {
                // Failed to decode WhatsApp data
            }
        }
    });
    // END WHATSAPP REVEAL AND TRACKING

    // SMS TRACKING
    singleCarPageParent.on("click", ".single-car-single-button-sms a", function (e) {
        const carId = $(this).data('car-id');
        if (carId) {
            trackAnalyticsEvent('sms_click', { car_id: carId, contact_type: 'seller' });
            trackAnalyticsEvent('vehicle_contact_intent', { car_id: carId, contact_type: 'sms' });
            trackMetaEvent('Contact', vehicleMetaPayload(carId, { contact_type: 'sms' }));
            csrfSafeAjaxPost('/ajax/track-phone-call', { car_id: carId }, function(response) {
                // SMS click tracked
            });
        }
    });

    // LEASING APPLICATION TRACKING — handled globally in main.js for all pages.

    // TRACKING FUNCTIONS
    function trackPhoneCall(carId, callType) {
        csrfSafeAjaxPost(
            '/ajax/track-phone-call',
            {
                car_id: carId,
                call_type: callType
            },
            function(response) {
                // Phone call tracked
            },
            function(xhr, status, error) {
                // Failed to track phone call
            }
        );
    }

    function trackWhatsAppInteraction(carId) {
        csrfSafeAjaxPost(
            '/ajax/track-whatsapp',
            {
                car_id: carId
            },
            function(response) {
                // WhatsApp interaction tracked
            },
            function(xhr, status, error) {
                // Failed to track WhatsApp interaction
            }
        );
    }

    function trackEmailInteraction(carId) {
        csrfSafeAjaxPost(
            '/ajax/track-email',
            {
                car_id: carId
            },
            function(response) {
                // Email interaction tracked
            },
            function(xhr, status, error) {
                // Failed to track email interaction
            }
        );
    }

    function trackLeasingApplication(carId) {
        csrfSafeAjaxPost(
            '/ajax/track-leasing-application',
            {
                car_id: carId
            },
            function(response) {
                // Leasing application tracked
            },
            function(xhr, status, error) {
                // Failed to track leasing application
            }
        );
    }

    // SHARE BUTTON FUNCTIONALITY
    singleCarPageParent.on("click", ".single-car-hero-button-share", function (e) {
        e.preventDefault();
        const shareUrl = $(this).attr('href');
        
        // Check if native sharing is available (mobile devices)
        if (navigator.share) {
            const currentUrl = window.location.href;
            const pageTitle = document.title;
            
            navigator.share({
                title: pageTitle,
                url: currentUrl
            }).catch(err => {
                // If native share fails or user cancels, open Facebook share dialog
                if (shareUrl) {
                    window.open(shareUrl, '_blank', 'width=600,height=400');
                }
            });
        } else {
            // Desktop: open Facebook share dialog in popup
            if (shareUrl) {
                window.open(shareUrl, '_blank', 'width=600,height=400');
            }
        }
    });
    // END SHARE BUTTON FUNCTIONALITY

});